import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Login from './components/Login';
import PrimeiroAcesso from './components/PrimeiroAcesso';
import Dashboard from './components/Dashboard';
import Pedidos from './components/Pedidos';
import Perfil from './components/Perfil';
import AIAssistant from './components/AIAssistant';
import ConsultaPedido from './components/ConsultaPedido';
import Footer from './components/Footer';

import WhatsAppButton from './components/WhatsAppButton';

function AppContent() {
  const location = useLocation();
  const hideFooterRoutes = ['/', '/primeiro-acesso'];
  const shouldShowFooter = !hideFooterRoutes.includes(location.pathname);

  return (
    <div className="app-layout">
      <main className="app-main">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/primeiro-acesso" element={<PrimeiroAcesso />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/pedidos" element={<Pedidos />} />
          <Route path="/consulta" element={<ConsultaPedido />} />
          <Route path="/perfil" element={<Perfil />} />
          <Route path="/ai-assistant" element={<AIAssistant />} />
        </Routes>
      </main>
      {shouldShowFooter && <Footer />}
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
